import { FunctionComponent, useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import ResetPasswordForm, { PasswordFeilds } from './ResetPasswordForm';
import usePostPortalResetPassword from '../../../hooks/useApi/usePostPortalResetPassword';

type FC = FunctionComponent;

const ChangePassword: FC = () => {
  const history = useHistory();
  const { PasswordToken } = useParams<{ PasswordToken: string }>();
  const [postostPortalResetPasswordResponse, postPortalResetPassword] = usePostPortalResetPassword({});
  const [passwordErrorMsg, setPasswordErrorMsg] = useState('');
  const [passwordError, setPasswordErorr] = useState(false);

  useEffect(() => {
    if (postostPortalResetPasswordResponse?.Success) {
      history.push('/');
    } else if (postostPortalResetPasswordResponse) {
      setPasswordErorr(true);
      setPasswordErrorMsg(postostPortalResetPasswordResponse.ErrorMessage);
    }
  }, [postostPortalResetPasswordResponse]);
  const handlers = {
    resetPassword: (values: PasswordFeilds, actions: any) => {
      postPortalResetPassword({
        Password: values.Password,
        PasswordToken: PasswordToken || '',
      });
      actions.setSubmitting(false);
    },
  };
  return (
    <>
      <ResetPasswordForm
        handleFormSubmit={handlers.resetPassword}
        hasError={passwordError}
        errorMsg={passwordErrorMsg}
        initialValues={{ Password: '' }}
      />
    </>
  );
};
export default ChangePassword;
